/** Seconds before a recovery link can be sent again. */
export const RESEND_COOLDOWN_SECONDS = 300;

/** Router-state key carrying the email that prefills the recovery email step. */
export const RECOVERY_EMAIL_STATE_KEY = 'recoveryEmail';

/** Support line shown on the access screens. */
export const SUPPORT_PHONE = '+51 989 704 398';
